// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTerms_ListInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /lgpd_terms
 *
 * Supports optional activeOnly filter via query params.
 */
import { registerContract } from './validate'

export interface LgpdTerms_ListInput {
activeOnly?: boolean
}

registerContract('LgpdTerms_ListInput', {
  activeOnly: { type: 'boolean', required: false },
})
